import { removeCookieCSR } from '@/app/api/CSR/removeCookieCSR'

const cleanApp = (reset?: () => void) => {
  removeCookieCSR('_IL-storeId')
  removeCookieCSR('_IL-storeReference')
  removeCookieCSR('_IL-selectedOpsModel')
  removeCookieCSR('_IL-selectedAddress')
  removeCookieCSR('_IL-cartId')
  removeCookieCSR('_IL-token')
  localStorage.clear()
  sessionStorage.clear()

  reset?.()
}

export default cleanApp
